var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"px-2 pt-2 sm:px-10 sm:pt-10 flow-root bg-main-bg h-full ccolumn-items w-full"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }